import React, { useContext, useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Login from "../pages/authentification_page/login_page/Login";
import MenuPage from "../pages/menu_page/MenuPage";
import Main from "../../src/pages/dashboards/Main";
import OverAll from "../subpages/revenue/overall/OverAll";
import OnePlan from "../subpages/revenue/oneplan/OnePlan";
import MaxPlan from "../subpages/revenue/maxplan/MaxPlan";
import SharePlan from "../subpages/revenue/shareplan/SharePlan";
import OverAlls from "../subpages/cost/overall/OverAlls";
import OnePlanCommission from "../subpages/cost/commission/oneplan-commission/OnePlanCommission";
import MaxPlanCommission from "../subpages/cost/commission/maxplan-commission/MaxPlanCommission";
import SharePlanCommission from "../subpages/cost/commission/shareplan-commission/SharePlanCommission";
import Others from "../subpages/cost/others/Others";
import Expenses from "../subpages/expenses/Expenses";
import Budget from "../subpages/budget/Budget";
import Loading from "../components/loading/Loading";
import { onAuthStateChanged } from "firebase/auth";
import { App } from "antd";
import { auth } from "../../src/pages/authentification_page/firebase-config";
import { AppContext } from "../../src/context/Context";
import ScrollToTop from "../utils/ScrollTop";
import NotFound from "../pages/not_found_page/NotFoundPage";

const Routers = () => {
  const { isAuthenticated, setIsAuthenticated, data, contextHolder } =
    useContext(AppContext);
  const { message } = App.useApp();

  // console.log("kkkakaka", Object.keys(data));

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(
      auth,
      async (user) => {
        const token = localStorage.getItem("lastLoginTime");
        if (user && token) {
          try {
            const convertTimeNow = Math.floor(Date.now() / 1000);

            const expiredToken = localStorage.getItem("lastLoginTime");

            if (convertTimeNow - expiredToken > 60 * 60 * 24) {
              message.error("Token is expired");
              await auth.signOut();
              localStorage.removeItem("lastLoginTime");
              setIsAuthenticated(false);
            } else {
              setIsAuthenticated(true);
              localStorage.setItem("lastLoginTime", Date.now() / 1000);
            }
          } catch (error) {
            console.error("Error refreshing token:", error);
            setIsAuthenticated(false);
          }
        } else {
          setIsAuthenticated(false);
          localStorage.removeItem("lastLoginTime");
        }
        setLoading(false);
      },
      [setIsAuthenticated]
    );

    return () => unsubscribe();
  }, [setIsAuthenticated]);

  if (loading || (Object.keys(data).length === 0 && isAuthenticated)) {
    return (
      <div
        style={{
          height: "100vh",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Loading size="large" />
      </div>
    );
  }

  const ProtectedRoute = ({ isAuthenticated, children }) => {
    return isAuthenticated ? children : <Navigate to="/" />;
  };

  return (
    <Router>
      <ScrollToTop />
      {contextHolder}
      <Routes>
        {/* ----------------------------------------------------------------public route--------------------------------------------------------- */}
        <Route path="/" element={isAuthenticated ? <MenuPage /> : <Login />} />

        {/* --------------------------------------------------Authenticated Routes --------------------------------------------------------- */}
        <Route
          path="/menupage"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              {" "}
              <MenuPage />{" "}
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/*"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Main />
            </ProtectedRoute>
          }
        >
          <Route path="revenue-income" element={<OverAll />} />
          <Route path="revenue-income/oneplan" element={<OnePlan />} />
          <Route path="revenue-income/maxplan" element={<MaxPlan />} />
          <Route path="revenue-income/shareplan" element={<SharePlan />} />

          <Route path="agentcommission" element={<OverAlls />} />
          <Route
            path="agentcommission/detail/oneplan"
            element={<OnePlanCommission />}
          />
          <Route
            path="agentcommission/detail/maxplan"
            element={<MaxPlanCommission />}
          />
          <Route
            path="agentcommission/detail/shareplan"
            element={<SharePlanCommission />}
          />

          <Route path="agentcommission/others" element={<Others />} />
          <Route path="expenses" element={<Expenses />} />
          <Route path="budget" element={<Budget />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default Routers;
